import JsBarcode from "jsbarcode";
import { openPrintWindow } from "@/lib/printWindow";

const CSS = `
  @page { size: A4; margin: 10mm; }
  body { font-family: system-ui, sans-serif; margin: 0; }
  .grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 6mm; padding: 4mm; }
  .label { border: 1px dashed #CBD5E1; padding: 6mm 4mm; text-align: center; break-inside: avoid; }
  .name { font-size: 11px; font-weight: 600; margin-bottom: 2mm; min-height: 24px; }
  .price { font-size: 14px; font-weight: 800; color: #2563EB; margin-top: 2mm; }
  svg { max-width: 100%; height: 50px; }
`;

const sanitizeCode = (s) => String(s == null ? "" : s).replace(/[^A-Za-z0-9 _.-]/g, "").slice(0, 64);

const barcodeSvg = (code) => {
  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  try {
    JsBarcode(svg, code || "0", { format: "CODE128", displayValue: true, fontSize: 10, height: 40, margin: 2 });
  } catch {
    return null;
  }
  return svg;
};

export function printBarcodeLabels(items) {
  if (!items || !items.length) return;
  openPrintWindow({
    title: "Etiquetas",
    css: CSS,
    features: "width=800,height=600",
    build: (body, el) => {
      const labels = items.map((p) => el("div", { class: "label" }, [
        el("div", { class: "name" }, (p.name || "").slice(0, 40)),
        barcodeSvg(sanitizeCode(p.barcode || (p.id || "").slice(-12))),
        el("div", { class: "price" }, `R$ ${(Number(p.price) || 0).toFixed(2).replace(".", ",")}`),
      ]));
      body.append(el("div", { class: "grid" }, labels));
    },
  });
}
